import generalTransformer from '@/services/general/filters/serverTableDataTransformer';

export function transformer(serverTableData) {
  if (!serverTableData.orderBy) {
    serverTableData.ascending = 0;
    serverTableData.orderBy = 'creationTime';
  }
  return generalTransformer(serverTableData);
}

export function transformerSupport(serverTableData) {
  if (!serverTableData.orderBy) {
    serverTableData.ascending = 0;
    serverTableData.orderBy = 'creationTime';
  }
  if (serverTableData.orderBy === 'planMedia') {
    serverTableData.orderBy = 'devisCommande.planMedia.code';
  }
  if (serverTableData.orderBy === 'commande') {
    serverTableData.orderBy = 'devisCommande.code';
  }
  if (serverTableData.orderBy === 'produit') {
    serverTableData.orderBy = 'produit.reference';
  }
  if (serverTableData.orderBy === 'dateDevisCommande') {
    serverTableData.orderBy = 'devisCommande.dateDevisCommande';
  }
  if (serverTableData.orderBy === 'dateTransmissionAuClient') {
    serverTableData.orderBy = 'devisCommande.dateTransmissionAuClient';
  }
  if (serverTableData.orderBy === 'dateTransmissionAuClub') {
    serverTableData.orderBy = 'devisCommande.dateTransmissionAuClub';
  }
  return generalTransformer(serverTableData);
}
